module.exports = __webpack_public_path__ + "img/masonry-banner-3.335ac61e.jpg";